module.exports = __webpack_public_path__ + "img/thermometer-100.1c1bf00f.svg";